<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();

const isEnabled = ref(false);

watch(
  currentAccount,
  account => {
    isEnabled.value = account?.settings?.require_resolve_reason === true;
  },
  { immediate: true }
);

const handleToggle = async () => {
  try {
    await updateAccount({ require_resolve_reason: isEnabled.value }, { silent: true });
    useAlert(t('GENERAL_SETTINGS.FORM.REQUIRE_RESOLVE_REASON.API.SUCCESS'));
  } catch {
    useAlert(t('GENERAL_SETTINGS.FORM.REQUIRE_RESOLVE_REASON.API.ERROR'));
    isEnabled.value = !isEnabled.value;
  }
};
</script>

<template>
  <div
    class="flex flex-col w-full outline-1 outline outline-n-container rounded-xl bg-n-solid-2 divide-y divide-n-weak"
  >
    <div class="flex flex-col gap-2 items-start px-5 py-4">
      <div class="flex justify-between items-center w-full">
        <h3 class="text-base font-medium text-n-slate-12">
          {{ t('GENERAL_SETTINGS.FORM.REQUIRE_RESOLVE_REASON.TITLE') }}
        </h3>
        <Switch v-model="isEnabled" @change="handleToggle" />
      </div>
      <p class="mb-0 text-sm text-n-slate-11">
        {{ t('GENERAL_SETTINGS.FORM.REQUIRE_RESOLVE_REASON.NOTE') }}
      </p>
    </div>
  </div>
</template>
